import { useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import qs from 'qs';
import { format, isToday, parseISO } from 'date-fns';

import { API_URL, get } from 'lib/network/api';
import FullLayout from 'layout/FullLayout';
import { sortByStartTime } from 'lib/sortByStartTime';
import SliderDate from 'components/SliderDate';
import InputSelected from 'components/InputSelected';
import CardPlaySchedule from './ComponentsPage/CardPlaySchedule';

const PlaySessionsSchedule = () => {
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  const currentParams = qs.parse(searchParams.toString(), { comma: true });

  const initialDate = currentParams.date ? parseISO(currentParams.date) : new Date();

  const [pickDate, setPickDate] = useState(initialDate);
  const [selected, setSelected] = useState(null);

  const [query, setQuery] = useState({
    page: 1,
    limit: 50,
    date: format(initialDate, 'yyyy-MM-dd'),
  });

  const optionData = [
    { id: 0, name: '6 Years', value: '6' },
    { id: 1, name: '8 Years', value: '8' },
    { id: 2, name: '10 Years', value: '10' },
  ];

  // Fetch data
  const fetchSessionsSchedule = async (query, currentParams) => {
    const { page, date, limit } = currentParams;

    const params = {
      page: page || query.page,
      limit: limit || query.limit,
      data_type: 'exhibition_play_schedule',
      date: date || query.date,
    };

    const filteredParams = Object.fromEntries(
      Object.entries(params).filter(
        ([_, value]) => value !== undefined && value !== null && value !== '',
      ),
    );

    return get(
      `${API_URL}/api/event/schedule/no-login?${qs.stringify(filteredParams, {
        arrayFormat: 'repeat',
      })}`,
    );
  };

  const { data, isLoading, isError } = useQuery({
    queryKey: ['fetchSessionsSchedule', query, currentParams],
    queryFn: async ({ queryKey }) => fetchSessionsSchedule(queryKey[1], queryKey[2]),
  });

  const playPackage = data?.exhibition_play_schedules || [];

  const formatPickDate = (paramsDate) => {
    const labelToday = isToday(paramsDate) ? 'Today, ' : '';
    return `${labelToday}${format(paramsDate, 'EEEE d MMMM')}`;
  };

  const onFilterByDate = (date) => {
    const formattedDate = format(date, 'yyyy-MM-dd');

    // Hindari update jika tanggal sama
    if (formattedDate === format(pickDate, 'yyyy-MM-dd')) return;

    setPickDate(date);
    setQuery((prev) => ({
      ...prev,
      date: formattedDate,
    }));

    const newParams = new URLSearchParams(searchParams);
    newParams.set('date', formattedDate);
    setSearchParams(newParams);
  };

  return (
    <FullLayout>
      <div className="relative">
        <div className="bg-kin-textsecondary shadow-md xl:pt-10 xl:pb-6 xl:px-0 pt-4 pb-2 px-4 lg:px-8 sticky top-[60px] z-10">
          <div className="container mx-auto">
            <h2 className="text-2xl text-kin-text font-semibold">Play Sessions</h2>
            <SliderDate pickDate={pickDate} setPickDate={onFilterByDate} />
            {/* <div className="hidden xl:flex flex-row justify-end gap-2 items-center">
              <InputSelected
                dataOption={optionData}
                selected={selected}
                setSelected={setSelected}
              />
              <InputSelected
                dataOption={optionData}
                selected={selected}
                setSelected={setSelected}
              />
              <InputSelected
                dataOption={optionData}
                selected={selected}
                setSelected={setSelected}
              />
            </div> */}
          </div>
        </div>
        <div className="container mx-auto">
          <div className="flex flex-col mt-0 md:mt-6 pb-4 gap-4">
            <div className="p-6 relative overflow-hidden">
              <div className="flex flex-col items-start md:flex-row md:items-center justify-between mb-4">
                <span className="text-base text-primary-main font-bold">
                  {formatPickDate(pickDate)}
                </span>
                <span className="text-sm text-kin-text font-light">
                  {playPackage.length} Play Sessions
                </span>
              </div>
              <div className="flex flex-col gap-4 text-kin-text">
                {sortByStartTime(playPackage).map((items, idx) => (
                  <CardPlaySchedule key={items.id || idx} item={items} />
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </FullLayout>
  );
};

export default PlaySessionsSchedule;
